import { render, staticRenderFns } from "./documents-status-card.vue?vue&type=template&id=c4b91646&"
import script from "./documents-status-card.vue?vue&type=script&lang=js&"
export * from "./documents-status-card.vue?vue&type=script&lang=js&"
import style0 from "./documents-status-card.vue?vue&type=style&index=0&id=c4b91646&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports